function initTimer() {
    document.querySelectorAll(".countdown-container").forEach(container => {
        var sectionId = container.id.replace("countdown-", "");

        var daysElement = document.getElementById("days-" + sectionId);
        var hoursElement = document.getElementById("hours-" + sectionId);
        var minutesElement = document.getElementById("minutes-" + sectionId);
        var secondsElement = document.getElementById("seconds-" + sectionId);

        var year = parseInt(container.dataset.year, 10);
        var month = parseInt(container.dataset.month, 10) - 1;
        var day = parseInt(container.dataset.day, 10);
        var hour = parseInt(container.dataset.hour, 10);
        var minute = parseInt(container.dataset.minute, 10);

        var endDate = new Date(Date.UTC(year, month, day, hour, minute));

        
        endDate.setHours(endDate.getHours() - 5);
        endDate.setMinutes(endDate.getMinutes() - 30);

        function updateTimer() {
            var now = new Date().getTime();
            var timeLeft = endDate.getTime() - now;

            if (timeLeft <= 0) {
                daysElement.innerText = "00";
                hoursElement.innerText = "00";
                minutesElement.innerText = "00";
                secondsElement.innerText = "00";
                clearInterval(timerInterval);
                return;
            }

            var days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
            var hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

            // Ensure two-digit formatting
            daysElement.innerText = days.toString().padStart(2, '0');
            hoursElement.innerText = hours.toString().padStart(2, '0');
            minutesElement.innerText = minutes.toString().padStart(2, '0');
            secondsElement.innerText = seconds.toString().padStart(2, '0');
        }

        var timerInterval = setInterval(updateTimer, 1000);
        updateTimer();
    });
}

document.addEventListener('DOMContentLoaded', function () {
    initTimer(document);
  });
  
  
document.addEventListener('shopify:section:load', function (event) {
initTimer(event.target);
});
  